// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module__spinner___276eT","rotate":"Spinner-module__rotate___Ep5tg"};